import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import JobService from "../../services/JobService";
import { JobOrder } from "../../interfaces/job.interface";
import Loader from "../../components/Loader/Loader";
import { useLoader } from "../../contexts/LoaderContext";
import "./AssignContainers.scss";

const AssignContainers: React.FC = () => {
  const { jobId, jobCode } = useParams<{ jobId: string; jobCode: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [jobOrder, setJobOrder] = useState<JobOrder | null>(null);
  const { showLoader, hideLoader } = useLoader();

  useEffect(() => {
    const fetchJobDetails = async () => {
      try {
        showLoader();
        setLoading(true);
        setError(null);
        const jId = parseInt(jobId ?? "0");
        const response = await JobService.getJobDetails(jId);
        console.log(response.data);
        if (!response.data.error) {
          setJobOrder(response.data.data);
        } else {
          console.error("Error in fetching job details");
          setError("Failed to load job details");
        }
      } catch (err: any) {
        setError(err.message || "An error occurred");
      } finally {
        setLoading(false);
        hideLoader();
      }
    };
    if (jobId) {
      fetchJobDetails();
    }
  }, [jobId, showLoader, hideLoader]);

  if (loading) {
    return <Loader />;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  if (!jobOrder) {
    return <div className="no-data">No job data available</div>;
  }

  return (
    <div className="assign-containers-page">
      <h1>Assign Containers for Job {jobCode}</h1>
      {/* Add your container assignment UI here */}
    </div>
  );
};

export default AssignContainers;
